<template>
  <div id="showroom-banner">
    <div class="banner-container">
      <div class="banner-title slate-bold">
        {{ selectedSchool ? selectedSchool.name : getTeamName }}
      </div>

      <div class="banner-customizations">
        <CustomizationBox v-if="showCustomizationsBox" />
        <div class="banner-image"></div>
        <div class="banner-gradient" :style="backgroundMainColor"></div>
        <div class="banner-actions" @click="toggleCustomizationBox">
          <div class="banner-action banner-action-customizations">
            <ColorPicker
              :colorPickerMode="colorPickerMode"
              :colorsToChange="projectColors"
              :hideLabels="true"
              :readOnly="true"
              @selectColor="handleSelectColor"
            />
            <img
              class="decoration-preview"
              :src="imgThumbnail"
              v-if="!customDecorationTextLoading"
            />
            <div class="decoration-preview" v-else>
              <Loader />
            </div>
          </div>
        </div>
      </div>
      <div class="banner-locker">
        <!-- Go to locker -->
        <router-link class="cart" :to="lockerRoute">
          <div
            v-if="quantityOfProductInLocker"
            class="locker-quantity slate-bold"
            title="quantity of locker's products"
          >
            {{ quantityOfProductInLocker }}
          </div>
          <img
            title="Your Locker"
            src="@/assets/icons/ui/cart-outline.png"
            alt="cart icon"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";
import CustomizationBox from "@/components/Projects/Showrooms/CustomizationBox/CustomizationBox.vue";
import Loader from "@/components/Utils/Loader";

export default {
  name: "ShowroomBanner",
  computed: {
    ...mapState(["lockerModule"]),

    ...mapGetters("project", ["projectColors"]),
    ...mapGetters("showroom", ["getTeamName"]),
    ...mapGetters("uploadLogos", ["editableLogo"]),

    ...mapState("project", ["typeOfProject", "paginationActive"]),
    ...mapState("dealer", ["rhino_code"]),

    ...mapState("showroom", [
      "selectedSchool",
      "mascot",
      "showCustomizationsBox",
      "customDecorationTextLoading",
      "showroomPath",
    ]),
    ...mapState("threekit", ["spiritwearThumbnail", "uniformThumbnail"]),

    imgThumbnail() {
      return this.editableLogo && this.editableLogo.content
        ? this.editableLogo.content
        : this.uniformThumbnail;
    },

    quantityOfProductInLocker() {
      return this.lockerModule?.locker?.products?.length;
    },

    lockerRoute() {
      const typeOfProject = this.typeOfProject + "s";

      return `/${typeOfProject}/${this.$router.currentRoute.params.dealer_code}/locker`;
    },

    gradient() {
      const color1 = this.projectColors[0]?.color?.hex ?? "#324281",
        color2 = this.projectColors[1]?.color?.hex ?? "#667AC7";

      return `background: linear-gradient(87.83deg, ${color1} 0%, ${color2} 100%);`;
    },

    backgroundMainColor() {
      return `background-color: ${
        this.projectColors[0]?.color?.hex ?? "#eceded"
      }`;
    },

    colorPickerMode() {
      return "multiple"
    },

    colorsToChange() {
      return this.showroomPath === "school" || this.showroomPath === "team" ? this.projectColors : [this.projectColors[0]]
    },
  },

  methods: {
    ...mapActions("showroom", [
      "updateShowroomColor",
      "toggleCustomizationBox",
    ]),

    handleSelectColor({ color, colorKey }) {
      this.updateShowroomColor({ colorId: color?.id, colorKey });
    },
  },

  components: {
    ColorPicker,
    CustomizationBox,
    Loader,
  },
};
</script>

<style lang="scss">
#app {
  #showroom-banner {
    display: flex;
    justify-content: center;
    background-color: #eceded;
    position: sticky;
    top: 0;
    z-index: 100;

    .banner-container {
      display: flex;
      align-items: center;
      flex: 1;
      position: relative;
      height: 5rem;
      max-width: 1440px;
      justify-content: space-between;

      & > * {
        height: 100%;
        display: flex;
        align-items: center;
      }

      .banner-title {
        font-style: normal;
        font-weight: 500;
        font-size: 1.75rem;
        line-height: 29px;
        text-transform: capitalize;
        color: #26262c;
        padding: 1.75rem;
        width: 50%;
      }

      .banner-customizations {
        display: flex;
        position: relative;
        max-width: 550px;
        width: 35%;
        height: 100%;

        .banner-image {
          flex: 1;
          background: url("/images/showroom/banner-bg.jpg");
          background-repeat: no-repeat;
          background-position: right;
          background-size: cover;
          height: 100%;
          width: 100%;
        }

        .banner-gradient {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.6;
          //background: linear-gradient(87.83deg, #5B6FB8 0%, #5C6FB9 5.97%, rgba(112, 131, 200, 0) 400.02%);
        }
        .banner-actions {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          max-width: 720px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 20px;
          cursor: pointer;

          .banner-action {
            width: 150px;
            display: flex;
            justify-content: center;
            align-items: center;

            .selected-colors {
              //                  width: 325px;
              display: flex;
              justify-content: center;
              margin: 0;
              .color-container {
                border-radius: 6px;
                padding: 0.25rem;
                transition: all 0.2s;
                width: fit-content;

                &:hover {
                  box-shadow: 0px 0px 10px -5px #00000063;
                }
                .color-circle {
                  margin: 0;
                  width: 25px;
                  height: 25px;
                }
              }
            }

            .decoration-preview {
              max-width: 100%;
              padding: 5px;
              margin-left: 15px;
              max-height: 100%;
              // background: white;
              border-radius: 5px;
              height: 30px;

              > .spinner-loader-container {
                padding: 3px 30px 3px 10px;
              }
            }
          }
        }
      }

      .banner-locker {
        display: flex;
        justify-content: center;
        width: 15%;
        max-width: 165px;
        .cart {
          position: relative;
          transition: all 0.2s;
          &:hover {
            transform: scale(1.1);
          }
          .locker-quantity {
            background: #d5000b;
            border-radius: 50%;
            color: white;
            position: absolute;
            top: -0.5rem;
            right: -0.5rem;
            height: 1.5rem;
            width: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
